import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './types'
import login from './modules/login';
import localization from './modules/localization';
import teacherCourse from './modules/teacherCourse';
import teacherCourseData from './modules/teacherCourseData';
import prepareCourse from './modules/prepareCourse';
import interaction from './modules/interaction';
import jpAccountInfo from './modules/jpAccountInfo';
import electronAccountInfo from './modules/electronAccountInfo';
import orgInfo from './modules/orgInfo';

Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        login,
        localization,
        teacherCourse,
        teacherCourseData, //上课页--学情分析--数据传递
        prepareCourse,
        interaction,
        jpAccountInfo,
        electronAccountInfo,
        orgInfo
    }
})